<template>
  <div class="setting-page flex-box">
    <div class="q-nav flex-box flex-col po-r" v-loading="navLoading">
      <div class="q-head flex-box ju-c al-c">
        <div class="flex-1 tx-c">问题导航</div>
        <i class="el-icon-plus font-20 mr10 cu-p" title="新增" @click="addNav"></i>
        <i class="el-icon-upload2 font-20 mr10 cu-p" title="导入" @click="importDialog=true"></i>
      </div>
      <div class="nav-box pl10 pr10 pt10 flex-1">
        <div :class="`nav-item flex-box al-c card-shadow cu-p pl10 pr10 ${activeNav.id===item.id?'active':''}`" v-for="item in navList" @click="activeNavChange(item)" :key="item.id">
          <div class="flex-1 tx-c ellipsis">{{item.name}}</div>
          <div class="q-num tx-r">{{item.questionCount}}</div>
          <i class="el-icon-delete font-20 cu-p ml10" @click="deleteNavDialog(item)"></i>
        </div>
      </div>
      <div class="nav-page po-a w100 tx-r" >
        <el-pagination
          small
          layout="prev, pager, next"
          @current-change="navPageChange"
          :pager-count="5"
          :page-size="navPage.size"
          :current-page.sync="navPage.current"
          :total="navPage.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="批量导入"
      :visible.sync="importDialog"
      width="30%"
      :before-close="importDialogClose">
      <ImportAndDownloadExcel ref="importAndDownloadExcel" :uplodData="{type: 'qa'}" downloadType="qa"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增问题导航"
      :visible.sync="addNavDialog"
      width="30%"
      :before-close="navDialogClose">
      <el-input v-model="newNav" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="navSubmit" :disabled="!newNav || addNavLoading" :loading="addNavLoading">确 定</el-button>
        <el-button @click="addNavDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="delNavDialogData.show"
      width="30%"
    >
      <span>请确认是否删除"{{delNavDialogData.data.name}}"?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delNav">确 定</el-button>
        <el-button @click="delNavDialogData.show = false">取 消</el-button>
      </span>
    </el-dialog>

    <div class="a-list flex-box flex-col po-r" v-loading="questionLoading">
      <div class="q-head flex-box ju-c al-c">
        <div class="flex-1 tx-c">{{activeNav.name}}-常见问题</div>
        <i class="el-icon-plus font-20 mr10 cu-p" title="新增" @click="addQuestion"></i>
        <!-- <i class="el-icon-upload2 font-20 mr10 cu-p" title="删除"></i> -->
      </div>
      <div class="answer-box pl10 pr10 pt10 flex-1 bg-w">
        <div :class="`answer-item flex-box al-c cu-p pl10 pr10 ${activeQuestion.id===item.id?'active':''}`" v-for="item in questionList" :key="item.id" @click="activeQuestionChange(item)">
          <el-tooltip class="item" effect="dark" :content="item.title" placement="right-end">
            <div class="flex-1 tx-l ellipsis question-title">{{item.title}}</div>
          </el-tooltip>
          <i class="el-icon-delete font-20 cu-p ml10" @click="deleteQuestionDialog(item)"></i>
        </div>
      </div>
      <div class="nav-page po-a w100 tx-r" >
        <el-pagination
          small
          layout="prev, pager, next"
          @current-change="questionPageChange"
          :pager-count="5"
          :page-size="questionPage.size"
          :current-page.sync="questionPage.current"
          :total="questionPage.total">
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="新增常见问题"
      :visible.sync="addQuestionDialog"
      width="30%"
      :before-close="questionDialogClose">
      <el-input v-model="newQuestion" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="questionSubmit" :disabled="!newQuestion || addQuestionLoading" :loading="addQuestionLoading">确 定</el-button>
        <el-button @click="addQuestionDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="delQuestionDialogData.show"
      width="30%"
    >
      <span>请确认是否删除"{{delQuestionDialogData.data.title}}"?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delQuestion">确 定</el-button>
        <el-button @click="delQuestionDialogData.show = false">取 消</el-button>
      </span>
    </el-dialog>

    <div class="flex-1 answer-editor">
      <el-form :model="activeQuestion" :rules="ruleValidate" ref="answerForm" v-if="activeQuestion.id" label-width="100px" style="width: 100%;">
        <el-form-item label="问题名称：" prop="title">
          <el-input v-model="activeQuestion.title" style="width: calc(100% - 85px);"></el-input>
        </el-form-item>
        <el-form-item label="问题答案：" prop="content">
          <el-tabs v-model="activeTabName" type="card" >
            <el-tab-pane label="编辑" name="edit">
              <div style="width: calc(100% - 85px);">
                <quillEditorCom v-model="activeQuestion.content"  />
              </div>
            </el-tab-pane>
            <el-tab-pane label="预览" name="view">
              <div style="width: calc(100% - 85px);" v-html="activeQuestion.content"></div>
            </el-tab-pane>
          </el-tabs>
          
        </el-form-item>
        <div class="tx-c" v-if="activeTabName==='edit'">
          <el-button type="primary" @click="answerSubmit" :disabled="updateLoading" :loading="updateLoading">保 存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import {questionGroupList, questionList, questionGroupSave, questionGroupDelete, questionSave, questionDelete, questionUpdate} from '@/api/management/QAHelper'
import quillEditorCom from '@/components/common/quillEditor.vue'
import ImportAndDownloadExcel from '@/components/dialog/common/importAndDownloadExcel'

export default {
  name: "setting",
  data() {
    return {
      navPage: {
        current: 1,
        total: 0,
        size: 20,
      },
      navList: [],
      activeNav: {},
      questionPage: {
        current: 1,
        total: 0,
        size: 20,
      },
      questionList: [],
      activeQuestion: {},
      navLoading: false,
      questionLoading: false,
      addNavDialog: false,
      addNavLoading: false,
      delNavDialogData: {
        show: false,
        data: {},
      },
      newNav: '',
      addQuestionDialog: false,
      addQuestionLoading: false,
      delQuestionDialogData: {
        show: false,
        data: {},
      },
      newQuestion: '',
      answer: '',
      ruleValidate: {
        title: [
          {required: true, message: '不能为空', trigger: 'blur'},
          {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
        ],
        content: [
          {required: true, message: '不能为空', trigger: 'blur'},
        ],
      },
      updateLoading: false,
      activeTabName: 'edit',
      importDialog: false,
    };
  },
  components: {
    quillEditorCom,
    ImportAndDownloadExcel,
  },
  computed: {
  },
  watch: {
    activeNav(val){
      this.initQuestionList()
    },
    'activeQuestion.content'(val){
    }
  },
  created() {
    this.initNavList()
  },
  methods: {
    importDialogClose(){
      this.$refs.importAndDownloadExcel.reset()
      this.importDialog=false
    },
    navPageChange(current){
      this.navPage.current = current;
      this.getNavList()
    },
    activeNavChange(item){
      this.activeNav = item;
    },
    async initNavList(){
      this.navPage.current = 1;
      await this.getNavList()

      this.activeNav = this.navList[0] || {};
    },
    getNavList(){
      let params = {
        current: this.navPage.current,
        size: this.navPage.size,
      }
      this.navLoading = true
      return new Promise((resolve, reject) => {
        questionGroupList(params)
        .then(({data}) => {
          if(data.code==0){
            this.navList = data.data.records || [];
            this.navPage.total = data.data.total;
            resolve()
          }else {
            this.$message.error(data.msg)
          }
        }).finally(() => {
          this.navLoading = false;
        })
      })
    },
    initQuestionList(){
      this.questionPage.current = 1;
      this.getQuestionList()
    },
    questionPageChange(current){
      this.questionPage.current = current;
      this.getQuestionList()
    },
    getQuestionList(){
      let params = {
        current: this.questionPage.current,
        size: this.questionPage.size,
        groupId: this.activeNav.id
      }
      this.questionLoading = true;
      questionList(params)
      .then(({data}) => {
        if(data.code == 0){
          this.questionList = data.data.records || [];
          this.questionPage.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.questionLoading = false;
      })
    },
    addNav(){
      this.addNavDialog = true;
    },
    navDialogClose(){
      this.newNav = '';
      this.addNavDialog = false;
    },
    navSubmit(){
      if(!this.newNav){
        return
      }
      if(this.newNav.length>10){
        this.$message.warning('请输入10字以内的问题导航')
        return
      }
      this.addNavLoading = true;
      questionGroupSave({name: this.newNav})
      .then(({data}) => {
        if(data.code == 0){
          this.$message.success('添加成功')
          this.initNavList()
          this.addNavDialog = false
        }else {
          this.$$message.error(data.msg)
        }
      }).finally(() => {
        this.addNavLoading = false
      })
    },
    deleteNavDialog(item){
      if(item.questionCount!=0){
        this.$message.warning('该导航下内容不为空不允许删除')
        return
      }
      this.delNavDialogData.show = true;
      this.delNavDialogData.data = item;
    },
    delNav(){
      questionGroupDelete({ids: this.delNavDialogData.data.id})
      .then(({data}) => {
        if(data.code == 0){
          this.$message.success('删除成功')
          this.delNavDialogData.show = false
          this.initNavList()
        }else {
          this.$message.error(data.msg)
        }
      })
    },
    addQuestion(){
      this.addQuestionDialog = true;
    },
    questionDialogClose(){
      this.newQuestion = '';
      this.addQuestionDialog = false;
    },
    questionSubmit(){
      if(!this.newQuestion){
        return
      }
      if(this.newQuestion.length>20){
        this.$message.warning('请输入20字以内的问题')
        return
      }
      this.addQuestionLoading = true
      questionSave({title: this.newQuestion, groupId: this.activeNav.id})
      .then(({data}) => {
        if(data.code == 0){
          this.$message.success('添加成功')
          this.initQuestionList()
          this.addQuestionDialog = false
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.addQuestionLoading = false
      })
    },
    activeQuestionChange(item){
      this.activeQuestion = JSON.parse(JSON.stringify(item))
    },
    answerSubmit(){
      this.$refs.answerForm.validate((valid) => {
        if(valid){
          this.updateLoading = true;
          let obj = {
            content: this.activeQuestion.content,
            id: this.activeQuestion.id,
            title: this.activeQuestion.title,
            groupId: this.activeQuestion.groupId,
          }
          questionUpdate(obj)
          .then(({data}) => {
            if(data.code == 0){
              this.$message.success('保存成功')
              this.initQuestionList();
            }else {
              this.$message.error(data.msg)
            }
          }).finally(() => {
            this.updateLoading = false;
          })
        }
      })
    },
    deleteQuestionDialog(item){
      this.delQuestionDialogData.show = true;
      this.delQuestionDialogData.data = item;
    },
    delQuestion(){
      questionDelete({ids: this.delQuestionDialogData.data.id})
      .then(({data}) => {
        if(data.code == 0){
          this.$message.success('删除成功')
          this.delQuestionDialogData.show = false
          this.initQuestionList()
        }else {
          this.$message.error(data.msg)
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.setting-page {
  height: 100%;
  .q-nav, .a-list {
    width: 240px;
    height: 100%;
    margin-right: 10px;
    background-color: #f9f9f9;
    .q-head {
      line-height: 60px;
      background-color: #e9e9e9;
    }
    .nav-page {
      z-index: 3;
      bottom: 0;
      background-color: #f9f9f9;
      /deep/ * {
        background-color: #f9f9f9;
      }
    }
    .nav-box {
      overflow-y: auto;
      padding-bottom: 40px;
      position: relative;
      .nav-item {
        height: 50px;
        background-color: #fff;
        border-radius: 4px;
        margin-bottom: 10px;
        position: relative;
        .q-num {
          width: 40px;
          color: #999;
        }
        >i {
          z-index: 2;
        }
        &.active::after {
          display: block;
          content: '';
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          border: #49A0FA 1px solid;
          border-radius: 4px;
        }
      }
    }
  }
  .a-list {
    border: 1px solid #ddd;
    .nav-page {
      /deep/ * {
        background-color: #fff;
      }
    }
    .answer-box {
      overflow-y: auto;
      padding-bottom: 40px;
      .answer-item {
        height: 50px;
        border-bottom: 1px solid #ddd;
        &.active {
          .question-title {
            color: #49A0FA;
          }
        }
      }
    }
  }
  .answer-editor {
    width: 0;
    overflow-y: auto;
  }
}
</style>